import { createApp,watch } from 'vue';
import App from './App.vue';
import './assets/tailwind.css'; // 引入 Tailwind CSS
import './styles/editorial.css'; // 编辑风设计令牌（全站共享）
import './styles/cards.css'; // 三 grid 共用的卡片基础样式（含 .fade-* 全局化）
import '@fortawesome/fontawesome-free/css/all.css';
import router from './router'; // 引入 Vue Router
import i18n from './i18n';
import { setMetaTag, setOgLocale, setCanonical, setStructuredData } from './utils/seo';

const app = createApp(App);

// 使用 Vue Router
app.use(router);
app.use(i18n)

// 初始化时更新 meta 标签
function updateInitialMetaTags() {
  const locale = i18n.global.locale.value;

  // 更新语言
  document.documentElement.lang = locale;

  // 更新标题和基础 meta
  document.title = i18n.global.t('interface.pageTitle.home');
  setMetaTag('description', i18n.global.t('meta.description'));
  setMetaTag('keywords', i18n.global.t('meta.keywords.home'));

  // 更新 Open Graph 标签
  setMetaTag('og:title', i18n.global.t('interface.pageTitle.home'), 'property');
  setMetaTag('og:description', i18n.global.t('meta.description'), 'property');
  setOgLocale(locale);
  setMetaTag('og:site_name', i18n.global.t('interface.ai_inspiration_hub'), 'property');

  // 更新 Twitter 卡片
  setMetaTag('twitter:title', i18n.global.t('interface.pageTitle.home'));
  setMetaTag('twitter:description', i18n.global.t('meta.description'));

  // 更新作者信息
  setMetaTag('author', i18n.global.t('interface.ai_inspiration_hub'));

  // 更新 canonical 链接
  setCanonical(`https://hub.bestreader.ai/${locale}/`);

  // 更新结构化数据
  setStructuredData({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: i18n.global.t('interface.ai_inspiration_hub'),
    description: i18n.global.t('meta.description'),
    url: `https://hub.bestreader.ai/${locale}/`,
    inLanguage: locale,
    potentialAction: {
      '@type': 'SearchAction',
      target: `https://hub.bestreader.ai/${locale}/search/{search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  });
}

// 监听语言变化
watch(() => i18n.global.locale.value, () => {
  updateInitialMetaTags();
});

// 初始化时更新 meta 标签
updateInitialMetaTags();

app.mount('#app');